export { default } from './AccordionItemCaret';
